import { render, staticRenderFns } from "./sidebarMenuList.vue?vue&type=template&id=28114fb8&scoped=true"
import script from "./sidebarMenuList.vue?vue&type=script&lang=js"
export * from "./sidebarMenuList.vue?vue&type=script&lang=js"
import style0 from "./sidebarMenuList.vue?vue&type=style&index=0&id=28114fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28114fb8",
  null
  
)

export default component.exports